import Vue from 'vue';
import configs from '@/plugins/configs.js';
import router from '@/router/index.js';
import i18n from '@/plugins/vue-i18n.js';
import axios from '@/plugins/axios.js';

export default {
    clearAuthUser({ commit }, redirectTo) {
        if (!configs.inIframe) {
            // Remove Sentry user
            Raven.setUserContext();

            // Remove Authorization header
            delete axios.defaults.headers.common.Authorization;

            // Remove auth user from local storage
            localStorage.setItem('authUser', JSON.stringify({}));
            localStorage.removeItem('authUserAccount');
        }

        // Cleanup
        commit('resetState');
        commit('appointment/resetState');
        commit('automation/resetState');
        commit('campaign/resetState');
        commit('chat/resetState');
        commit('contact/resetState');

        Vue.nextTick(() => {
            if (redirectTo) {
                router.push(redirectTo);
            } else {
                router.push({ name: 'auth.login' });
            }
        });
    },

    async fetchTemplatePlaceholders({ commit, state }) {
        const response = await axios.get('templates/placeholders', {
            params: {
                account_id: state.authUser.account.id,
            },
        });

        commit('setTemplatePlaceholders', response.data.data);
    },

    async fetchUser({ state, dispatch }) {
        const response = await axios.get('auth-user');
        const authUser = response.data.data;

        authUser.access_token = state.authUser.access_token;

        dispatch('setAuthUser', Object.assign(authUser, response.data.data));
        dispatch('fetchTemplatePlaceholders');

        if (response.data.data.account.monthly_segments_limit) {
            dispatch('fetchSegmentsUsage', {
                account_id: response.data.data.account.id,
                start_date: moment().startOf('month').format(),
                end_date: moment().endOf('month').format(),
            });
        }

        return response;
    },

    setAuthUser({ commit }, authUser) {
        if (!authUser.account && authUser.accounts) {
            const storedAccount = JSON.parse(localStorage.getItem('authUserAccount')) || {};
            const account = authUser.accounts.find(a => a.id == storedAccount.id);

            authUser.account = account || authUser.accounts[0];
        }

        commit('setAuthUser', authUser);

        // Add Sentry user
        Raven.setUserContext(authUser);

        if (!configs.inIframe) {
            // Save it to local storage
            localStorage.setItem('authUser', JSON.stringify(authUser));
        }

        // Set Authorization header
        if (authUser.access_token) {
            axios.defaults.headers.common.Authorization = `Bearer ${authUser.access_token}`;
        }
    },

    setAuthUserAccount({ commit, state }, account) {
        commit('setAuthUserAccount', account);

        if (!configs.inIframe) {
            localStorage.setItem('authUser', JSON.stringify(state.authUser));
            localStorage.setItem('authUserAccount', JSON.stringify(account));
        }
    },

    /**
     * Load all partners from database
     */
    async fetchPartners({ commit }) {
        const response = await axios.get('partners');
        const partners = response.data.data;

        partners.unshift({
            id: -1,
            name: i18n.t('global.general.none'),
        });

        commit('setPartners', partners);

        return partners;
    },

    async fetchSegmentsUsage({ commit }, payload) {
        const response = await axios.get('usage/segments-count', { params: payload });

        commit('setSegmentsUsage', response.data.data);
    },
};
